import { useNavigate } from "react-router-dom";
import { AuthenticationStatus, getAuthStatus } from "../services/authenticator-service";
import { useEffect } from "react";
import { TaskpaneReadContainer } from "../components/Taskpane/TaskpaneReadContainer";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
    },
  },
});

export const TaskpanePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    async function getAuthState() {
      const authState = await getAuthStatus();

      if (authState !== AuthenticationStatus.LoggedIn) {
        console.info("Not authenticated: navigating to /start");
        navigate("/start");
      }
    }

    getAuthState().catch((error: unknown) => {
      console.error(error);
    });
  }, [navigate]);

  return <TaskpanePageInjectable />;
};

export const TaskpanePageInjectable = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="flex flex-col h-full bg-neutral-50">
        <div className="flex flex-col grow min-h-0">
          <TaskpaneReadContainer></TaskpaneReadContainer>
        </div>
      </div>
    </QueryClientProvider>
  );
};
